(function () {
  function getSlides(modal) {
    const slider = modal?.querySelector('.js-popup-slider');
    if (!slider) return [];
    return Array.from(slider.querySelectorAll('.swiper-slide'));
  }

  function hydrateSlide(slide) {
    if (!slide || slide.dataset.modalHydrated === 'true') return;

    const template = slide.querySelector('.product-media-modal__slide-template');
    if (!template) return;

    slide.appendChild(template.content.cloneNode(true));
    slide.dataset.modalHydrated = 'true';
  }

  function hydrateAround(modal, activeIndex) {
    const slides = getSlides(modal);
    if (!slides.length) return;

    const indexes = new Set([activeIndex, activeIndex - 1, activeIndex + 1]);

    indexes.forEach(function (index) {
      if (index >= 0 && index < slides.length) {
        hydrateSlide(slides[index]);
      }
    });
  }

  function resolveSlideIndex(modal, opener) {
    const slides = getSlides(modal);
    if (!slides.length) return 0;

    const mediaId = opener?.getAttribute('data-media-id');
    if (mediaId) {
      const matchedIndex = slides.findIndex(function (slide) {
        return slide.dataset.mediaId === mediaId;
      });
      if (matchedIndex >= 0) return matchedIndex;
    }

    const popupSwiper = modal.querySelector('.js-popup-slider')?.swiper;
    if (popupSwiper && typeof popupSwiper.activeIndex === 'number') {
      return popupSwiper.activeIndex;
    }

    return 0;
  }

  function prepareForOpen(modal, opener) {
    if (!modal) return 0;

    const targetIndex = resolveSlideIndex(modal, opener);
    hydrateAround(modal, targetIndex);

    const popupSwiper = modal.querySelector('.js-popup-slider')?.swiper;
    if (popupSwiper && popupSwiper.activeIndex !== targetIndex) {
      popupSwiper.slideTo(targetIndex, 0);
      hydrateAround(modal, targetIndex);
    }

    return targetIndex;
  }

  window.ProductMediaModalLazy = {
    hydrateSlide: hydrateSlide,
    hydrateAround: hydrateAround,
    prepareForOpen: prepareForOpen,
  };
})();
